import { createActionGroup } from '@ngrx/store';

export const SocieteComposantRattachementActions = createActionGroup({
  source: 'Societe Composant Rattachement',
  events: {}
});
